// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"193":"4f050a1b","213":"0b3567bf","531":"f4c70462","586":"0e3227a8","787":"7dd975fb","875":"53dcaf23"}[chunkId] + ".chunk.js";
};